import { render, staticRenderFns } from "./m_openOnlineExam.vue?vue&type=template&id=72152796&scoped=true"
import script from "./m_openOnlineExam.vue?vue&type=script&lang=js"
export * from "./m_openOnlineExam.vue?vue&type=script&lang=js"
import style0 from "./m_openOnlineExam.vue?vue&type=style&index=0&id=72152796&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72152796",
  null
  
)

export default component.exports